import React from "react";
import CommonLayout from "../../../../layouts/commonLayout/CommonLayout";
import CusomizeCalender from "./calender/CusomizeCalender";
import TabBar from "../../../../components/tabbar/TabBar";

function MakeAppointment() {
  return (
    <CommonLayout>
      {/* <TabBar title={"Make An Appointment"} /> */}
      <div className="mt-4">
        <CusomizeCalender />
      </div>
    </CommonLayout>
  );
}

export default MakeAppointment;
